import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import instance from "../../Interceptor/api_instance";
import debounce from "lodash.debounce";
import { customStyles } from "../Utility/ReactSelectStyles";
import React, { useMemo } from "react";

const SealInventorySearch = ({ onSelect, selectedOption }) => {
    const {t} = useTranslation();
    const filterOptions = async (inputValue) => {
        if (!inputValue || inputValue.length < 1) return [];

        try {
            const res = await instance.get(`safety/seals/?seal_number=${inputValue}&is_active=true`);
            return res.data.results.map((seal) => ({
                value: seal.id,
                label: seal.seal_number,
            }));
        } catch (err) {
            console.error("Failed to fetch seals: ", err);
            return [];
        }
    };

    // Debounce filterOptions and return a wrapped function that resolves a Promise
  // ✅ Debounce filterOptions and return a wrapped function that resolves a Promise
  const debouncedLoadOptions = useMemo(() => {
    const wrapped = debounce((inputValue, callback) => {
      filterOptions(inputValue).then(callback);
    }, 1000); // 500ms debounce

    return (inputValue) =>
      new Promise((resolve) => wrapped(inputValue, resolve));
  }, []);

  return (
    <AsyncSelect
        cacheOptions
        defaultOptions={false}
        loadingMessage={() => t("general.loading")}
        loadOptions={debouncedLoadOptions}
        onChange={(option) => onSelect(option)}
        placeholder={t("forms.type.vehicle.search.visitor.search")}
        noOptionsMessage={() => t("forms.type.vehicle.search.visitor.not-found")}
        isClearable
        name="supplier"
        className="search-select"
        styles={customStyles}
        unstyled={true}
        value={selectedOption}
    />
  )
}

export default React.memo(SealInventorySearch)